/** Where the skip link lands. Also set as the `id` on the shell's `<main>`. */
export const MAIN_CONTENT_ID = 'main-content';

/**
 * The first thing the keyboard reaches on every page, and the only way past the
 * navigation without walking through it.
 *
 * The sidebar offers around thirteen destinations plus a workspace switcher, so
 * reaching the page itself by keyboard meant a tab through all of them, on every
 * navigation. There was no skip link anywhere in the application.
 *
 * Visually hidden until focused, which is the whole convention: it must not
 * occupy space for a reader using a pointer, and it must be unmissable for one
 * who has just pressed Tab. `sr-only` alone would hide it from sight even when
 * focused, so the focus state reverses every part of it.
 */
export function SkipLink() {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="bg-background text-foreground focus-visible:ring-ring sr-only rounded-md px-3 py-2 text-sm font-medium shadow-raised focus-visible:not-sr-only focus-visible:absolute focus-visible:top-2 focus-visible:left-2 focus-visible:z-50 focus-visible:ring-3 focus-visible:outline-none"
    >
      Skip to content
    </a>
  );
}
